// @flow strict
import { Button, Modal, Table } from 'antd';
import { useEffect, useState } from 'react';
import { getAllReferRules } from '../../../../api/refer';
import NewRedeemRule from './NewRule';
import SingleRule from './SingleRule';
import "./RedeemRules.css"; // Add a CSS file for better styling

function RedeemRules() {
  const [addModal, setAddModal] = useState(false);
  const [referRules, setReferRules] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 500);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 500);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchReferRules = async () => {
    setFetching(true);
    try {
      const res = await getAllReferRules();
      if (res?.data?.referRules) setReferRules(res.data.referRules);
    } catch (error) {
      console.log(error);
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    fetchReferRules();
  }, []);

  const columns = [
    {
      title: "Points",
      dataIndex: "points",
      key: "points",
      align: "center",
    },
    {
      title: "Token",
      dataIndex: "token",
      key: "token",
      align: "center",
    },
    {
      title: "Day Extend",
      dataIndex: "days",
      key: "days",
      align: "center",
      render: (days) => <p>{days || 0}</p>,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      align: "center",
      render: (_, rule) => <SingleRule setReferRules={setReferRules} rule={rule} />,
    },
  ];

  return (
    <div className="redeem-rules-container">
      <div className="table-header">
        <h3 className="table-title">Redeem Rules</h3>
        <Button 
          className="add-rule-btn" 
          onClick={() => setAddModal(true)}
        >
          + New Rule
        </Button>
      </div>
      <Table
        dataSource={referRules}
        columns={columns}
        loading={fetching}
        bordered
        scroll={isMobile ? { x: 500 } : undefined}
      />
      <Modal
        title="New Redeem Rule"
        open={addModal}
        onCancel={() => setAddModal(false)}
        footer={null}
      >
        <NewRedeemRule setAddModal={setAddModal} setReferRules={setReferRules} />
      </Modal>
    </div>
  );
}

export default RedeemRules;
